import React from 'react';
import { Controller } from 'react-hook-form';
import CheckboxInput from '../../inputs/checkbox/checkbox';
import { FormProps } from '../../../shared/interfaces/form';

interface FormCheckboxProps {
  item: FormProps;
  index: number;
  baseId: string;
  errors: any;
  control: any;
  isDisabled: boolean;
  setValue: (name: string, value: any) => void;
  getValues: (name?: string | string[]) => any;
  handleCheckboxChange?: (value: boolean, fieldName: string) => void;
}

const FormCheckbox = ({
  item,
  index,
  baseId,
  errors,
  control,
  isDisabled,
  setValue,
  getValues,
  handleCheckboxChange
}: FormCheckboxProps) => {
  
  return (
    <Controller
      key={`checkbox-${index}-${baseId}`}
      name={item.name}
      control={control}
      defaultValue={item.value || false}
      rules={item.rules}
      render={({ field }) => (
        <CheckboxInput
          value={field.value}
          onChange={(value: boolean) => handleCheckboxChange?.(value, field.name)}
          label={{ inputProps: { 'aria-label': item.placeholder } }}
          isDisabled={isDisabled}
        />
      )}
    />
  );
};

export default FormCheckbox;